import { hasPermission } from '../../../utils'

export const canManageGroup = (group, user) => {
  return (
    hasPermission(user, 'directory.constituent.view_all_constituents') ||
    user.is_admin ||
    user.district === group?.district
  )
}

export const canDeleteGroup = (group, user) => {
  return (
    canManageGroup(group, user) &&
    hasPermission(user, 'directory.delete_constituentgroup')
  )
}
